import { useTranslation } from 'react-i18next';
import { formatPrice } from '@/lib/format-utils';
import { MoneyTransaction } from '@/types/money-models';

interface Props {
    moneyTransactions: MoneyTransaction[];
}

export default function BalanceSummary({ moneyTransactions }: Props): JSX.Element {
    const { t } = useTranslation();

    const totalsByCurrency = moneyTransactions.reduce((acc, transaction) => {
        const currency = transaction.currency;
        if (!acc[currency]) {
            acc[currency] = 0;
        }
        acc[currency] += Number(transaction.amount);
        return acc;
    }, {} as Record<string, number>);

    if (Object.keys(totalsByCurrency).length === 0) {
        return <></>;
    }

    return (
        <div className="flex gap-4 mb-4">
            {Object.entries(totalsByCurrency).map(([currency, total]) => (
                <div key={currency} className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm min-w-[200px]">
                    <div className="text-xs text-gray-500 uppercase font-bold mb-1">
                        {t('total')} ({currency})
                    </div>
                    <div className="text-2xl font-bold text-gray-700">
                        {formatPrice(total)} <span className="text-sm font-normal text-gray-400">{currency}</span>
                    </div>
                </div>
            ))}
        </div>
    );
}
